import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../queryKeys';
import { getCallDisposition } from 'services/api/getCallDisposition';

export const useGetCallDispositions = () => {
    const { data, isLoading, ...rest } = useQuery({
        queryKey: queryKeys.callDispositions,
        queryFn: () => getCallDisposition(),
    });

    return { callDispositions: data, isCallDispositionsLoading: isLoading, ...rest };
};
